import CitySEOHead from "@/components/feature/CitySEOHead";
import CTHeroSection from "./components/HeroSection";
import CTCitiesDirectory from "./components/CitiesDirectory";
import CTStateResources from "./components/StateResources";
import CTFAQSection, { faqs } from "./components/FAQSection";
import CTFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function ConnecticutPage() {
  return (
    <>
      <CitySEOHead
        city="Connecticut"
        state="Connecticut"
        stateAbbr="CT"
        route="/states/connecticut"
        title="Connecticut Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Connecticut — Hartford, New Haven, Stamford, Bridgeport, Waterbury, and Greenwich. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Connecticut, United States"
        geoPosition="41.6032;-73.0877"
        faqs={faqs.map((f) => ({ q: f.question, a: f.answer }))}
        servicesSchema={servicesList}
        serviceAreaDesc="Fast Passport Center serves Connecticut travelers with expedited and emergency passport processing. Headquarters in Washington, DC with remote service across all Connecticut cities."
      />
      <div className="font-sans">
        <CTHeroSection />
        <CTCitiesDirectory />
        <CTStateResources />
        <CTFAQSection />
        <SEOCrossLinks state="CT" />
        <CTFinalCTA />
      </div>
    </>
  );
}